import React, { useState, useEffect } from 'react'
import linkIcon from '../../../../assets/images/link.svg'
import editIcon from '../../../../assets/images/editIcon.svg'
import downloadIcon from '../../../../assets/images/download.svg'
import { useNavigate } from 'react-router-dom'
// import { getCompanyType } from '../../../../redux/authSlice'
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import { fetchCompanyCertificateDetails, getCompanyDetailsById } from '../../../../redux/adminSlice'
import { getDate } from '../../../../helpers/helperFunction'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';


const ReviewActiveCompany = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { companyId } = useParams();
    // const activeCompanyDetails = []
    const activeCompanyDetails = useSelector(state => state.admin.getCompanyData?.data?.[0]) || {};
    const companyCertificateDetails = useSelector((state) => state.admin.certificateData);

    // useEffect to fetch company details
    useEffect(() => {
        // console.log('companyId', companyId)
        dispatch(getCompanyDetailsById(companyId));
    }, [dispatch, companyId]); // Added dispatch to dependency array

    useEffect(() => {
        const queryParams = { type: "certificates", pageNumber: 1, pageSize: 12 }
        dispatch(fetchCompanyCertificateDetails({ companyId, queryParams }))
    }, [dispatch, companyId])

    // console.log('Review Active Company ::', companyId, activeCompanyDetails)
    const editCompanyFun = (companyId, step, actionType, activeCompanyDetails) => {
        navigate(`/edit-active-orders/${actionType}/${step}/${companyId}`, {
            state: { actionType: 'edit', companyId: companyId, activeCompanyDetails: activeCompanyDetails }
        });
    }

    const downloadCompanyCerFun = () => {
        console.log('Certificate download clicked')
    }

    const responsive = {
        superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 5 },
        desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3 },
        tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
        mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
    };
    return (
        <>
            <nav aria-label="breadcrumb" className="bread-box">
                <div>
                    <h1 className="fprimary">Review Active Company </h1>
                    <h5 className="">Review carefully company details</h5>
                </div>
                <div>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="#">Company</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Review Company</li>
                    </ol>
                </div>
            </nav>
            {/* Company Details */}
            <div className="card mt-3 bg-stage">
                <div className="card-body">
                    <div className='row'>
                        <div className="col-md-4">
                            <h1 className="fprimary">Company details&nbsp;&nbsp;<button className="icon-clay mr-2" onClick={() => editCompanyFun('edit', 1, activeCompanyDetails.companyId, activeCompanyDetails)}>
                                <img src={editIcon} alt="Edit Company" /></button></h1>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">Company name</p>
                                    <div className="bg-slash font-14">{activeCompanyDetails.companyName}</div>
                                </div>
                                <div className="ps-2 right-box w-100">
                                    <p className="font-13 mb-0">Company type</p>
                                    <div className="bg-slash font-14">{activeCompanyDetails?.companyTypeName || 'N/A'}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">

                                <div className="ps-2 right-box w-100">
                                    <p className="font-13 mb-0">URL</p>
                                    <div className="bg-slash font-14">{activeCompanyDetails.url}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mt-5 ml-2'>
                        <h1 className="fprimary">Description</h1>
                        {/* <p className='mt-4'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec orci tellus, hendrerit quis congue non, maximus nec nisi. Vivamus porttitor turpis velit, sit amet finibus magna bibendum vel. Aenean malesuada ultricies neque, at feugiat enim commodo ut. Sed suscipit rhoncus erat, mattis facilisis orci. Ut consequat ut purus a tincidunt. Nullam sit amet convallis sapien. In accumsan ante et ante vulputate,</p> */}
                        <p className='mt-4'>{activeCompanyDetails.description}</p>

                    </div>
                </div>
                {/* Contact Details */}
                <div className="card-body">
                    <div className='mb-2'>
                        <h1 className="fprimary">Contact Details&nbsp;&nbsp;<button className="icon-clay mr-2" onClick={() => editCompanyFun('edit', 3, activeCompanyDetails.companyId, activeCompanyDetails)}>
                            <img src={editIcon} alt="Edit Company" /></button></h1>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">Mobile No.</p>
                                    <div className="bg-slash font-14">{activeCompanyDetails.phoneNumber}</div>
                                </div>
                                <div className="ps-2 right-box w-100">
                                    <p className="font-13 mb-0">Addition Mobile No.</p>
                                    <div className="bg-slash font-14">{activeCompanyDetails?.additionalPhone || '-'}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">Email-id</p>
                                    <div className="bg-slash font-14">{activeCompanyDetails.emailAddress}</div>
                                </div>
                                <div className="ps-2 right-box w-100">
                                    <p className="font-13 mb-0">Addition Email Id</p>
                                    <div className="bg-slash font-14">{activeCompanyDetails.additionalEmail}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 pe-2">
                                    <p className="font-13 mb-0">GST/ VAT/ Tax id *</p>
                                    <div className="bg-slash font-14">{activeCompanyDetails.gst}</div>
                                    {/* <span className="ms-2"><img src={linkIcon} alt="Link" /></span> */}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                {/* Locations Details */}
                <div className="card-body">
                    <div className='mb-2'>
                        <h1 className="fprimary">Location &nbsp;&nbsp;<button className="icon-clay mr-2" onClick={() => editCompanyFun('edit', 2, activeCompanyDetails.companyId, activeCompanyDetails)}>
                            <img src={editIcon} alt="Edit Company" /></button></h1>
                    </div>
                    <div className="row mt-4">
                        {/* <p>Plot No. 23-24, union Vaishali Nagar, West Delhi, Delhi-110096, India</p> */}
                        <p>
                            {activeCompanyDetails.address} {'\n'}
                            {/* {activeCompanyDetails.isdCode} {'\n'}
                            {activeCompanyDetails.phoneNumber} {'\n'}
                            {activeCompanyDetails.referredName} {'\n'}
                            {activeCompanyDetails.referredName} {'\n'}
                            {activeCompanyDetails.referredName} {'\n'}
                            {activeCompanyDetails.referredName} {'\n'} */}

                        </p>
                    </div>
                </div>
                {/* Referred By */}
                <div className="card-body">
                    <div className='mb-2'>
                        <h1 className="fprimary">Referred  By&nbsp;&nbsp;<button className="icon-clay mr-2" onClick={() => editCompanyFun('edit', 4, activeCompanyDetails.companyId, activeCompanyDetails)}>
                            <img src={editIcon} alt="Edit Company" /></button></h1>
                    </div>
                    <div className="row mt-4">
                        <p className=''>
                            {activeCompanyDetails.referredName} {'\n'}
                            {activeCompanyDetails.referredCompanyName} {'\n'}
                            {activeCompanyDetails.referredEmail} {'\n'}
                            {activeCompanyDetails.referredPhone} {'\n'}
                            {activeCompanyDetails.awards} {'\n'}

                        </p>
                    </div>
                </div>
            </div>
            <hr />
            <div className='mt-4'>
            {companyCertificateDetails.length > 0 ? (
                    <div className="col-md-12 mb-5">
                        <div className='mb-3 mt-2'>
                            <h1 className="fprimary">Certificate Details</h1>
                        </div>
                        <Carousel responsive={responsive}>
                            {companyCertificateDetails.map((certificate, index) => (
                                <div className="" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'normal', marginTop: '35px' }}>
                                    <div className="card bg-leves m-1" key={index} style={{ width: '90%', minWidth: '300px' }}>

                                        <div className="card-body">
                                            <div className="certificate-card">
                                                <div className="cir-box"></div>
                                                <div className="content-box text-center mt-5">
                                                    <h4 className="font-16 mb-1">{certificate.certificateName}</h4>
                                                    <h6>{certificate.certificateIssuingBodyName}</h6>
                                                    <p>
                                                        {certificate.dateOfIssue && getDate(certificate.dateOfIssue) || ''}
                                                        &nbsp;To&nbsp;
                                                        {certificate.dateOfExpiry && getDate(certificate.dateOfExpiry) || ''}
                                                    </p>
                                                    <button className="icon-clay me-2" onClick={() => downloadCompanyCerFun(certificate, 'delete')}>
                                                        <img src={downloadIcon} alt="Download Certificate" />
                                                    </button>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>))
                            }
                        </Carousel>
                    </div>
                ) : <>
                <div className='mb-3 mt-2'>
                    <h1 className="fprimary">Certificate Details</h1>
                </div>
                <div className="row mt-4">
                    <div className="col-md-2">
                        <div className="d-flex justify-content-between indect">
                            <div className="left-box w-100 border-end pe-2 overflowHandle">
                                <div className="bg-slash font-14 overflowHandle">No Certificate Found!</div>
                            </div>
                        </div>
                    </div>
                </div>
            </>}
            </div>
        </>
    )
}
export default ReviewActiveCompany

{/* Certificate */ }
{/* <div className='mt-4'>
                <h1 className="fprimary mt-4" >Certificate Details</h1>
                <div className="row mt-5 mb-5">
                    <div className="col-md-3">
                        <div className="card bg-leves">
                            <div className="card-body">
                                <div className="certificate-card">
                                    <div className="cir-box">

                                    </div>
                                    <div className="content-box text-center mt-3">
                                        <h4 className="font-16 mb-1">Certificate Name</h4>
                                        <h6>Certificate issuing Body</h6>
                                        <p>12 Jan 2024 To 11 Jan 2025</p>
                                        <button className="icon-clay mr-2" onClick={() => downloadCompanyCerFun(activeCompanyDetails.orderId, 'edit')}>
                                            <img src={downloadIcon} alt="Download Certificate" /></button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div> */}